import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import Loading from "../components/Loading";
import { userSelector } from "../components/PrivateRoute";
import UserTechAssisTrackingPerm from "../enum/UserTechAssisTrackingPerm";
import UserType from "../enum/UserType";

export default function RootApp() {

    const history = useHistory();
    const match = useRouteMatch();
    const user = useSelector(userSelector);

    useEffect(() => {
        init();
    }, []);

    async function verifyAuth() {
        const queryString = window.location.hash;
        const urlParams = new URLSearchParams(queryString.replace(`#${match.url}?`, ''));
        let redirect = urlParams.get('r') || '';
        if (user) {
            if (user.type === UserType.Commbox || user.type === UserType.Undefined) {
                if (user.tech_assis_tracking_perm === UserTechAssisTrackingPerm.YesExclusive) {
                    history.replace('/system/techAssisTracking');
                } else {
                    if (redirect) {
                        var Buffer = require('buffer/').Buffer;
                        history.replace(Buffer.from(redirect, 'base64').toString('utf-8').replace('#', ''));
                    } else {
                        history.replace('/system/prodEng/open');
                    }
                }
            } else {
                history.replace('/support/tickets/open');
            }
        } else {
            history.replace('/login' + (redirect ? '?r=' + redirect : ''));
        }
    }

    async function init() {
        await verifyAuth();
    }

    return <Loading />;
}